import * as React from "react";
import { forwardRef } from "react";
const SvgFlag = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" ref={ref} {...props}><path fill="currentColor" d="m6.45 8.607 6.762-1.812-2.708-2.38L11.659 1 4.898 2.812 6.45 8.607zM2.966 3.33a1 1 0 0 0-.707 1.224l2.6 9.704a1 1 0 0 0 1.932-.518l-2.6-9.704a1 1 0 0 0-1.225-.707z" /></svg>;
const ForwardRef = forwardRef(SvgFlag);
export default ForwardRef;